module.exports = __webpack_public_path__ + "img/select_comments.b143e55e.png";